// Copyright (c) 2005-2019, Coveo Solutions Inc.
"use strict";
var PluginOptions = (function () {
    function PluginOptions() {
        this.analyticsCustomMetadata = {};
        this.analyticsEndpointUri = "/coveo/rest/v6/analytics/";
        this.boostExpressions = "";
        this.clientLanguageFieldName = "";
        this.clientLanguageName = "";
        this.componentRefreshCallback = null;
        this.defaultSortType = "Relevancy";
        this.defaultSortField = "";
        this.defaultSortCriteriaNoSpace = "Relevancy";
        this.defaultSortCriteriaLowercase = "relevancy";
        this.enableClientSideLogging = false;
        this.externalCollections = [];
        this.externalSources = [];
        this.externalSourcesFromCurrentTab = [];
        this.externalCollectionsFromCurrentTab = [];
        this.filterExpression = "";
        this.filterResultOnLatestVersion = true;
        this.filterResultsOnCurrentCulture = false;
        this.indexSourceName = "";
        this.isEditingInPageEditor = false;
        this.isInitialized = false;
        this.isPreviewingInPageEditor = false;
        this.isPreviewingInPageEditorWithSimulatedDevice = false;
        this.keepOmniboxSuggestionsProvidersDefaultOrdering = true;
        this.latestVersionFieldName = "";
        this.omniboxDataRowIndexCounter = 0;
        this.pageFullPath = "";
        this.pageName = "";
        this.restEndpointUri = "/coveo/rest/";
        this.resultListInfiniteScrollContainer = window;
        this.searchboxPlaceholderText = "";
        this.searchRedirectionUrl = "";
        this.searchRedirectionItemName = "";
        this.sendToSitecoreAnalytics = false;
        this.sitecoreItemId = "";
        this.sitecoreItemUri = "";
        this.siteName = "";
        this.userContext = {};
    }
    return PluginOptions;
}());
exports.__esModule = true;
exports["default"] = PluginOptions;



//////////////////
// WEBPACK FOOTER
// ./Base/PluginOptions.ts
// module id = 3
// module chunks = 0